import React, {useEffect, useState} from "react";
import {Alert, Col, Row} from "reactstrap";
import NTMTable from "../components/Table/NTMTable";
import {useQuery, useQueryClient} from "react-query";
import {Client} from "../redux/utils";
import NTMLoadingModal from "../components/Modal/NTMLoadingModal";
import {MoneyCell} from "../components/Table/tableCells";
import moment from "moment";
import NTMButton from "../components/Buttons";
import SweetAlert from "react-bootstrap-sweetalert";
import {useSnackbar} from "notistack";

let client = new Client();

export default function RegistryPage() {

	const {enqueueSnackbar} = useSnackbar();
	const [tableState, setTableState] = useState({
		page: 0,
		pageSize: 20,
		filtered: [],
		sorted: []
	});
	const [requestState, setRequestState] = useState(tableState);

	useEffect(() => {
		const timeout = setTimeout(() => setRequestState(tableState), 300);
		return () => clearTimeout(timeout);
	}, [tableState]);

	function manageError(e) {
		enqueueSnackbar(client.getErrorMessage(e), {variant: "error"});
	}

	let {
		data = {content: [], totalPages: 0},
		isLoading,
		isFetching,
		isError,
		error,
		refetch
	} = useQuery(
		["registry", requestState],
		() => {
			const sort = requestState.sorted[0];
			const params = requestState.filtered.reduce((result, filter) => {
				const value = filter.value == null ? "" : String(filter.value);
				if (value.trim()) result[filter.id] = value;
				return result;
			}, {
				page: requestState.page,
				size: requestState.pageSize,
				sortBy: sort ? sort.id : "date",
				desc: sort ? sort.desc : true
			});
			return client.get("transactions/registry/page", "", {
				timeout: 30000,
				params
			}).then(response => response.data);
		},
		{retry: false, keepPreviousData: true}
	);
	let queryClient = useQueryClient();
	let [modal, setModal] = useState();

	let list = data.content.map(d => {
		return {
			...d,
			ben: d.externalFund || d.shop || d.diocese || "-",
			val: d.validated ? "OK" : "-"
		};
	});

	function closeModal() {
		setModal(null);
	}

	function validate(tid) {
		closeModal();
		client
			.get(`transactions/registry/${tid}/validate`)
			.then(() => enqueueSnackbar("Validata", {variant: "success"}))
			.catch(manageError)
			.finally(() => queryClient.invalidateQueries("registry"))
	}

	function setError(tid) {
		closeModal();
		client
			.update(`Invalidata manualmente il ${moment().format("DD-MM-YYYY")}`, `transactions/registry/${tid}`)
			.then(() => enqueueSnackbar("Invalidata", {variant: "success"}))
			.catch(manageError)
			.finally(() => queryClient.invalidateQueries("registry"))
	}

	function validateCell(registry) {
		if (registry.validated) return "OK";
		else if (registry.error) return "-";
		else return <div>
				<NTMButton
					primary
					onClick={() => setModal(
						<SweetAlert
							showCancel
							confirmBtnText={"Conferma"}
							cancelBtnText={"Annulla"}
							cancelBtnBsStyle={"default"}
							title={"Confermi?"}
							onConfirm={() => validate(registry.transactionId)}
							onCancel={closeModal}
						>
							{`Vuoi validare manualmente la transazione di ${(registry.total / 100).toFixed(2)}€ effettuata da ${registry.email}?`}
						</SweetAlert>
					)}
				>Valida</NTMButton>
				<NTMButton
					red
					onClick={() => setModal(
						<SweetAlert
							showCancel
							confirmBtnText={"Conferma"}
							confirmBtnBsStyle={"danger"}
							cancelBtnText={"Annulla"}
							cancelBtnBsStyle={"default"}
							title={"Confermi?"}
							onConfirm={() => setError(registry.transactionId)}
							onCancel={closeModal}
						>
							{`Vuoi invalidare manualmente la transazione di ${(registry.total / 100).toFixed(2)}€ effettuata da ${registry.email}? Verrà indicata come "Invalidata manualmente"`}
						</SweetAlert>
					)}
				>Invalida</NTMButton>
			</div>;

	}

	return <div className="animated fadeIn">
		{isLoading && <NTMLoadingModal/>}
		{modal}
		{isError && <Alert color="danger" role="alert">
			Impossibile caricare il registro: {client.getErrorMessage(error)}{" "}
			<NTMButton primary onClick={() => refetch()}>Riprova</NTMButton>
		</Alert>}
		<Row>
			<Col>
				<NTMTable
					title={"Registro transazioni"}
					filterable={true}
					header={
						[
							{
								Header: 'ID',
								accessor: 'transactionId' // String-based value accessors!
							},
							{
								Header: 'Email',
								accessor: 'email' // String-based value accessors!
							},
							{
								Header: 'Nome',
								accessor: 'userFirstName' // String-based value accessors!
							},
							{
								Header: 'Cognome',
								accessor: 'userLastName',
							},
							{
								Header: 'Data',
								accessor: 'date',
								width: 180,
								sortMethod: (a, b) => moment(b, "DD/MM/YYYY HH:mm") - moment(a, "DD/MM/YYYY HH:mm")
							},
							{
								Header: 'Validata',
								accessor: 'val',
								Cell: props => validateCell(props.original)
							},
							{
								Header: 'Dispositivo',
								accessor: 'device',
							},
							{
								Header: 'Tot',
								accessor: 'total',
								Cell: props => <MoneyCell value={props.original.total / 100}/>
							},
							{
								Header: 'Tipo',
								accessor: 'type',
								sortable: false,
							},
							{
								Header: 'Errore',
								accessor: 'error',
								width: 200,
							},
							{
								Header: 'Beneficiario',
								accessor: "ben",
								width: 300,
								sortable: false,
							}]}
					defaultPageSize={20}
					pageSizeOptions={[5, 20, 50, 100, 200]}
					body={list}
					manual
					pages={data.totalPages}
					loading={isFetching}
					onFetchData={state => setTableState({
						page: state.page,
						pageSize: state.pageSize,
						filtered: state.filtered || [],
						sorted: state.sorted || []
					})}
				/>
			</Col>
		</Row>
	</div>;

}

/*
customButtons={
							<React.Fragment>
								<div style={{display: "flex"}}>
									<div style={{display: "flex", flexGrow: 1}}>
										<NTMButton onClick={closeModal}>Annulla</NTMButton>
									</div>
									<div style={{display: "flex", flexGrow: 2}}>
										<NTMButton red
										           onClick={() => setError(registry.transactionId)}>Invalida</NTMButton>
										<NTMButton primary
										           onClick={() => validate(registry.transactionId)}>Conferma</NTMButton>
									</div>
								</div>
							</React.Fragment>
						}
 */
